import React, { useEffect, useState } from "react";
import { Card, Col } from "react-bootstrap";
import { SlEnergy } from 'react-icons/sl';
import { TbFlame } from 'react-icons/tb';
import { BsFillBuildingsFill, BsFillDeviceSsdFill } from 'react-icons/bs';
import { MdOutlineOilBarrel, MdOutlineSolarPower } from 'react-icons/md';
import EnergoPagination from "../shared/EnergoPagination";
import EnergoCard from "../shared/EnergoCard";


/**
 * BuildingComponent
 * 
 * used to display information and Anlagen from selected Building
 * 
 * @param {building} props Building object
 * @returns gui as cards to display
 */
const BuildingComponent = (props) => {

    const [currentView, setCurrentView] = useState([]); // state used for pagination
    const [currentPage, setCurrentPage] = useState(1); // state used for selected pagination page
    const anlageCount = Math.ceil(props.anlagen.length / 3); // number of pages needed


    // Effect when props.anlagen gets data or data is changed
    useEffect(() => {
        let data_arr = [];
        if (props.anlagen.length > 0) {
            for (let i = 0; i < 3; i++) {
                if (props.anlagen[i] !== undefined) {
                    data_arr.push(props.anlagen[i]);
                }
            }
        }
        setCurrentView(data_arr);
    }, [props.anlagen])


    useEffect(() => {
        var start = (currentPage - 1) * 3;
        var end = currentPage * 3;
        setCurrentView(props.anlagen.slice(start, end));
    }, [currentPage])


    // GUI
    return (
        <>
            <Col xs="12" md="6" xl="6">
                {props.building ?
                    <EnergoCard
                        icon={<BsFillBuildingsFill className="text-light" size="30" />}
                        title="Gebäude"
                    >
                        <p><small className="text-muted">Straße &nbsp;</small> {props.building.street}</p>
                        <p><small className="text-muted">PLZ &nbsp;</small> {props.building.zip}</p>
                        <p><small className="text-muted">Ort &nbsp;</small> {props.building.city}</p>
                        <p hidden={props.building.x_objektbezeichnung === "False"}><small className="text-muted">Objektbezeichnung &nbsp;</small>{props.building.x_objektbezeichnung}</p>
                    </EnergoCard>
                    : null}
            </Col>
            <Col xs="12" md="6" xl="6">
                <EnergoCard
                    icon={<BsFillDeviceSsdFill size={29} />}
                    title="Anlagen"
                >
                    {props.anlagen && props.anlagen.length > 0 ?
                        currentView.map(anlage => (
                            <>
                            <p key={anlage.id}>
                                <a onClick={e => { e.preventDefault(); props.selected[0] === anlage.id ? props.setSelected([]) : props.setSelected([anlage.id, anlage.x_studio_field_mWMGR]) }} href={`/select/${anlage.id}`} className={props.selected[0] === anlage.id ? "link-light shadow-lg" : "link-energo-dark"}
                                    style={props.selected[0] === anlage.id ? { padding: "5px", backgroundColor: "#a2c13f", textDecoration: "none", borderRadius: "15px" } : null}
                                >
                                    {
                                        anlage.x_studio_field_3eKe0 === "Strom" ?
                                            <SlEnergy className={props.selected[0] === anlage.id ? "text-light" : "text-energo"} size="22" /> :
                                            anlage.x_studio_field_3eKe0 === "Gas" ?
                                                <TbFlame size="22" className={props.selected[0] === anlage.id ? "text-white" : "text-info"} /> :
                                                anlage.x_studio_field_3eKe0 === "Oil" ?
                                                    <MdOutlineOilBarrel size="22" className={props.selected[0] === anlage.id ? "text-white" : "text-danger"} /> :
                                                    anlage.x_studio_field_3eKe0 === "Strom-Einspeisung" ?
                                                        <MdOutlineSolarPower size="22" className={props.selected[0] === anlage.id ? "text-white" : "text-warning"} /> :
                                                        null
                                    }
                                    &nbsp;{anlage.x_studio_field_mWMGR} &nbsp;

                                    {
                                        anlage.x_studio_field_6T9W2 !== "False" || anlage.x_adresse_abw_top !== "False" ?
                                            anlage.x_studio_field_6T9W2 !== "False" ?
                                                `Top ${anlage.x_studio_field_6T9W2}`
                                                :
                                                `Top ${anlage.x_adresse_abw_top}`
                                            :
                                            anlage.x_anlagenverwendung_detail !== "False" ?
                                                anlage.x_anlagenverwendung_detail
                                                :
                                                'Allgemeine Liegenschaftsteile'
                                    }
                                </a>
                            </p>
                            <div className="text-center" hidden={anlageCount < 2}>
                                <EnergoPagination max={anlageCount} current={currentPage} select={setCurrentPage} />
                            </div>
                            </>
                        ))
                        : "Keine Anlagen vorhanden..."}
                </EnergoCard>
            </Col>
        </>
    )
}

export default BuildingComponent;